import React, { useContext, useState } from "react";
import { Aside, EditButton } from "sprint-common-web";

import { DeliveryEndpointsDataContext } from "../../../../../common/data/lookup-data-providers/DeliveryEndpointsDataProvider";
import { EditDeliveryInfoForm } from "./EditDeliveryInfoForm";

export const EditDeliveryInfoButton: React.VFC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const { isLoading } = useContext(DeliveryEndpointsDataContext);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    return (
        <>
            <EditButton onClick={openSidebar} isLabeled label="Edit" testId="edit-delivery-info" />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar} isLoading={isLoading}>
                <EditDeliveryInfoForm onCancel={closeSidebar} onSubmit={closeSidebar} />
            </Aside>
        </>
    );
};
